import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const getThemePreferences = themeState => {
  const {
    colorMode,
    dark,
    light,
    shape,
    spacing,
    typography
  } = themeState;
  const themePreferences = colorMode === 'auto' ? [light, dark] : [themeState[colorMode]];
  [shape, spacing, typography].forEach(themeId => {
    if (themeId) {
      themePreferences.push(themeId);
    }
  });
  if (getBooleanFF('platform.design-system-team.border-checkbox_nyoiu')) {
    themePreferences.push(`${themePreferences.includes('dark') ? 'dark' : 'light'}-new-input-border`);
  }

  // Load spacing by default
  if (!themePreferences.includes('spacing')) {
    themePreferences.push('spacing');
  }
  return [...new Set(themePreferences)];
};